module.exports = __webpack_public_path__ + "static/media/cog-solid.5fa8d3f4.svg";